// Helper to convert direct URLs to Proxy URLs (with optional userId for stream tracking)
export const secureUrl = (originalUrl, type, userId = null, contentTitle = null, userEmail = null, userName = null) => {
    if (!originalUrl) return "";

    // If already a proxy URL, just add metadata if needed
    if (originalUrl.startsWith('/api/proxy')) {
        let proxyUrl = originalUrl;
        if (userId && !proxyUrl.includes('userId=')) {
            proxyUrl += `&userId=${encodeURIComponent(userId)}`;
        }
        if (contentTitle && !proxyUrl.includes('contentTitle=')) {
            proxyUrl += `&contentTitle=${encodeURIComponent(contentTitle)}`;
        }
        if (userEmail && !proxyUrl.includes('userEmail=')) {
            proxyUrl += `&userEmail=${encodeURIComponent(userEmail)}`;
        }
        if (userName && !proxyUrl.includes('userName=')) {
            proxyUrl += `&userName=${encodeURIComponent(userName)}`;
        }
        return proxyUrl;
    }

    // Check if it's an exposed IPTV URL (broaden check to catch any http stream)
    const isIPTV = originalUrl.includes('/movie/') ||
        originalUrl.includes('/series/') ||
        originalUrl.includes('/live/') ||
        originalUrl.includes('line.dino.ws') ||
        originalUrl.includes('line.eggiptv.vip') ||
        originalUrl.includes('Player_api');

    if (isIPTV || originalUrl.startsWith('http://')) {
        const parts = originalUrl.split('/');
        const filename = parts[parts.length - 1];

        if (filename.includes('.') || originalUrl.includes('/live/')) {
            let id, ext;
            if (filename.includes('.')) {
                [id, ext] = filename.split('.');
            } else {
                id = filename;
                ext = 'ts';
            }

            let category = 'movie';
            if (originalUrl.includes('/series/')) category = 'series';
            else if (originalUrl.includes('/live/')) category = 'live';

            if (id && ext) {
                let proxyUrl = `/api/proxy/stream?id=${id}&ext=${ext}&category=${category}`;
                if (userId) proxyUrl += `&userId=${encodeURIComponent(userId)}`;
                if (contentTitle) proxyUrl += `&contentTitle=${encodeURIComponent(contentTitle)}`;
                if (userEmail) proxyUrl += `&userEmail=${encodeURIComponent(userEmail)}`;
                if (userName) proxyUrl += `&userName=${encodeURIComponent(userName)}`;
                return proxyUrl;
            }
        }
    }
    return originalUrl;
};
